import { ChangeEvent } from 'react';

export enum RadioGroupLayouts {
  Row = 'row',
  Column = 'column',
}

export interface RadioOption {
  id: string;
  label: string;
  disabled?: boolean;
}

export interface RadioGroupProps {
  id: string;
  label: string;
  options: RadioOption[];
  helpText?: string;
  errorText?: string;
  layout?: RadioGroupLayouts;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  selected?: string;
}
